var _rect, _rect2, _rect3, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 120,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.667,
    height: 98.667,
    fill: "url(#empty_svg__a)",
    rx: 1.333,
    transform: "matrix(-1 0 0 1 94.666 10.667)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.333,
    height: 25.333,
    x: 46.666,
    y: 50.667,
    fill: "url(#empty_svg__b)",
    rx: 1.333,
    transform: "rotate(180 46.666 50.667)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.333,
    height: 20,
    fill: "url(#empty_svg__c)",
    rx: 1.333,
    transform: "matrix(-1 0 0 1 118.667 73.333)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.816 34.667H49.334v44.477a7.52 7.52 0 0 0 7.522 7.523h45.114l-4.037-1.761a9.19 9.19 0 0 1-5.517-8.515z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#595D61",
    d: "M92.816 34.667H49.334v44.477a7.52 7.52 0 0 0 7.522 7.523h45.114l-4.037-1.761a9.19 9.19 0 0 1-5.517-8.515zM103.344 44.311h7.323v32.31a10.15 10.15 0 0 1-8.696 10.045"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#595D61",
    d: "M58.468 45.861h24.794v9.333H58.468zM58.468 70.821h25.674M58.468 64.131h25.674"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__a",
    x1: 10.44,
    x2: 11.743,
    y1: 211.14,
    y2: 4.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#F7A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__b",
    x1: 48.482,
    x2: 48.976,
    y1: 104.878,
    y2: 51.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#F7A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__c",
    x1: 1.816,
    x2: 2.124,
    y1: 42.799,
    y2: 1.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#F7A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty_svg__d",
    width: 53.336,
    height: 53,
    x: 48.834,
    y: 34.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.667,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.879167 0 0 0 0 0.879167 0 0 0 0 0.879167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5891_67931"
  })))));
};
export default SvgEmpty;